// src/sectors/pilates/settings/ui/SettingsUi.jsx
import React from 'react';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';
import { alpha, useTheme as useMuiTheme } from '@mui/material/styles';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

export function SectionCard({ icon, title, subtitle, children, right }) {
  const theme = useMuiTheme();
  return (
    <Card
      sx={{
        borderRadius: '22px',
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[6],
        overflow: 'hidden',
      }}
    >
      <MDBox
        sx={{
          p: { xs: 1.6, sm: 2.25 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1.25,
        }}
      >
        <MDBox sx={{ display: 'flex', alignItems: 'center', gap: 1.2, minWidth: 0 }}>
          <MDBox
            sx={{
              width: 40,
              height: 40,
              borderRadius: '14px',
              display: 'grid',
              placeItems: 'center',
              background: alpha(theme.palette.info.main, 0.1),
              border: `1px solid ${alpha(theme.palette.info.main, 0.18)}`,
              flex: '0 0 auto',
            }}
          >
            <Icon sx={{ fontSize: 20, opacity: 0.9 }}>{icon}</Icon>
          </MDBox>

          <MDBox sx={{ minWidth: 0 }}>
            <MDTypography variant="h6" fontWeight="bold" sx={{ lineHeight: 1.1 }} noWrap>
              {title}
            </MDTypography>
            {subtitle ? (
              <MDTypography variant="caption" sx={{ color: 'text.secondary' }} noWrap>
                {subtitle}
              </MDTypography>
            ) : null}
          </MDBox>
        </MDBox>

        {right ? <MDBox sx={{ flex: '0 0 auto' }}>{right}</MDBox> : null}
      </MDBox>

      <Divider />
      <MDBox sx={{ p: { xs: 1.6, sm: 2.25 } }}>{children}</MDBox>
    </Card>
  );
}

/**
 * ✅ TabActions artık "footer" gibi kullanılacak.
 * - Tab container'ın en altında yer almalı.
 * - sticky=true olursa scroll'da da görünür kalır (opsiyonel).
 */
export function TabActions({ saving, dirty, onReset, onSave, sticky = true }) {
  const theme = useMuiTheme();
  const isDark = theme.palette.mode === 'dark';

  const footerSx = sticky
    ? {
        position: 'sticky',
        bottom: 0,
        zIndex: 2,
        mt: 2,
        pt: 1.25,
        pb: 1.25,
        px: { xs: 1, sm: 0 },
        background: isDark
          ? `linear-gradient(180deg, ${alpha(theme.palette.background.default, 0)} 0%, ${alpha(
              theme.palette.background.default,
              0.92
            )} 40%, ${alpha(theme.palette.background.default, 0.98)} 100%)`
          : `linear-gradient(180deg, ${alpha(theme.palette.background.default, 0)} 0%, ${alpha(
              '#fff',
              0.86
            )} 40%, ${alpha('#fff', 0.95)} 100%)`,
        backdropFilter: 'blur(8px)',
      }
    : { mt: 2 };

  return (
    <MDBox sx={footerSx}>
      <MDBox
        sx={{
          display: 'flex',
          gap: 1,
          justifyContent: 'flex-end',
          flexWrap: 'wrap',
        }}
      >
        <MDButton
          variant="outlined"
          color="dark"
          disabled={saving || !dirty}
          onClick={onReset}
          sx={{
            borderRadius: '14px',
            textTransform: 'none',
            fontWeight: 800,
            minWidth: 120,
          }}
        >
          Sıfırla
        </MDButton>

        <MDButton
          variant="contained"
          color="info"
          disabled={saving || !dirty}
          onClick={onSave}
          sx={{
            borderRadius: '14px',
            textTransform: 'none',
            fontWeight: 900,
            minWidth: 140,
          }}
        >
          {saving ? 'Kaydediliyor...' : 'Kaydet'}
        </MDButton>
      </MDBox>
    </MDBox>
  );
}
